import { DEMO_EMAIL, DEMO_MAILTO } from "@/config";

export function CtaBand({ onOpenDemo }: { onOpenDemo: () => void }) {
  return (
    <section style={{ padding: "0 24px clamp(64px,9vw,104px)" }}>
      <div style={{ maxWidth: "1120px", margin: "0 auto", background: "var(--brand-deep)", borderRadius: "20px", padding: "clamp(44px,7vw,76px) clamp(24px,5vw,64px)", textAlign: "center" }}>
        <h2 style={{ margin: "0 auto 16px", fontSize: "clamp(26px,3.6vw,38px)", fontWeight: 600, lineHeight: 1.2, letterSpacing: "-.012em", color: "var(--on-deep)", maxWidth: "18em", textWrap: "pretty" }}>Sehen Sie Ihre eigenen Anfragen im Cockpit.</h2>
        <p style={{ margin: "0 auto 32px", fontSize: "16px", lineHeight: 1.65, color: "var(--on-deep-quiet)", maxWidth: "36em", textWrap: "pretty" }}>In einer halben Stunde zeigen wir Ihnen den Ablauf — gern mit Beispielen aus Ihrem Tagesgeschäft. Unverbindlich.</p>
        <button type="button" className="btn-invert" onClick={onOpenDemo}>Demo starten
          <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"></path><path d="M13 6l6 6-6 6"></path></svg>
        </button>
        <p style={{ margin: "22px 0 0", fontSize: "14px" }}><a className="cta-mail" href={DEMO_MAILTO}>{DEMO_EMAIL}</a></p>
      </div>
    </section>
  );
}
